import { TActivity } from '../../types/types';
export const activities: TActivity[] = [
  {
    id: 'rec0E9XP4tMJjyrXl',
    order: 9,
    type: 'DIALOG_IMAGE',
    site: ['IDEEV'],
    thematique: 'ASCENSEURS',
    text: 'Pour les personnes à mobilité réduite, seul cet ascenseur doit être utilisé en cas d’incendie.​',
    characterImg: 'img_miniature_alix.png',
    image: 'img_asset_32_ascenseur.png',
    characterName: 'Alix',
  },
  {
    id: 'rec0NiZF6Rn7D1z7G',
    order: 21,
    type: 'CLICK_OBJECT',
    site: ['HM'],
    thematique: 'ASCENSEURS',
    text: 'Et enfin, sélectionnez les étages accessibles aux étudiants et sans badges',
    answers: [
      {
        text: '404,301,84',
        isCorrect: true,
      },
      {
        text: '674,299,83',
        isCorrect: false,
      },
      {
        text: '404,500,82',
        isCorrect: true,
      },
      {
        text: '676,499,81',
        isCorrect: true,
      },
      {
        text: '944,497,78',
        isCorrect: true,
      },
      {
        text: '405,702,82',
        isCorrect: true,
      },
      {
        text: '675,701,81',
        isCorrect: true,
      },
    ],
    feedbackCorrect:
      'Exactement ! ​<br />Chaque ascenseur a ses particularités d’accès. Pour les Plots Enseignements, il vous faudra badger sur le palier. Ne vous inquiétez pas, vous allez vite vous y retrouver.',
    feedbackIncorrect:
      'Pas tout à fait. Chaque ascenseur a ses particularités d’accès. Pour les Plots Enseignements, il vous faudra badger sur le palier. Ne vous inquiétez pas, vous allez vite vous y retrouver. ​',
    background: 'img_bg_ascenceur.jpg',
    characterImg: 'img_miniature_alix.png',
    image: 'img_asset_58_clic-image.png',
    characterName: 'Alix',
  },
  {
    id: 'rec0VUCZK5GNM3N3c',
    order: 6,
    type: 'DIALOG',
    site: ['IDEEV'],
    thematique: 'ECLAIRAGES',
    text: 'C’est le cas pour les sanitaires, les douches, les couloirs, les escaliers, et le hall quand la luminosité extérieure est faible. ',
    background: 'img_bg-laboratory.png',
    characterImg: 'img_chr_eva2.png',
    characterName: 'Eva',
  },
  {
    id: 'rec0iwzSUS5cyt8bF',
    order: 2,
    type: 'DIALOG',
    site: ['IDEEV', 'HM'],
    thematique: 'CVC',
    text: 'Bon, il y a pas mal de choses à savoir… 700 tonnes de gaines, 13km de réseaux PVC, 1700 radiateurs, 800 ventilo-convecteurs…',
    background: 'img_bg_cvc-regulateur.jpg',
    characterImg: 'img_chr_cyril2.png',
    characterName: 'Cyril',
  },
  {
    id: 'rec1IHMFmOEq6ItFB',
    order: 13,
    type: 'DIALOG',
    site: ['IDEEV', 'HM'],
    thematique: 'STORES',
    text: 'Le basculement du mode été en mode hiver est fait de façon automatique en suivant un calendrier saisonnier.​ ​Voyons voir ce que vous avez retenu ! ',
    background: 'img_bg_store1.jpg',
    characterImg: 'img_chr_sami1.png',
    characterName: 'Sami',
  },
  {
    id: 'rec1LG4lzzlkNfz5x',
    order: 9,
    type: 'DIALOG',
    site: ['HM'],
    thematique: 'ECLAIRAGES',
    text: 'Dans les salles de cours, de TD et les bureaux, les sources lumineuses peuvent être graduées. Ce mode reste actif tant que le détecteur détecte une présence. Dans le cas contraire, il repassera en mode auto. ​',
    background: 'img_bg_couloir.jpg',
    characterImg: 'img_chr_eva1.png',
    characterName: 'Eva',
  },
  {
    id: 'rec1PTKtWKwOHvtYi',
    order: 12,
    type: 'DIALOG',
    site: ['IDEEV', 'HM'],
    thematique: 'STORES',
    text: "Qu'est-ce que je peux vous dire d'autre... ? Ah oui. En hiver, en mode auto, les volets montent le matin et redescendent le soir à 100%. En été, c’est l’inverse pour éviter la chaleur dans les bâtiments.​",
    background: 'img_bg_store1.jpg',
    characterImg: 'img_chr_sami2.png',
    characterName: 'Sami',
  },
  {
    id: 'rec1UgYIWzxs0zn3a',
    order: 3,
    type: 'DIALOG',
    site: ['IDEEV'],
    thematique: 'ASCENSEURS',
    text: 'Vous pouvez donc les utiliser mais il est préférable, si vous le pouvez, de prendre les ESCALIERS !​',
    background: 'img_bg_ascenceur.jpg',
    characterImg: 'img_chr_alix1.png',
    characterName: 'Alix',
  },
  {
    id: 'rec1vlew24nfWZLYa',
    order: 5,
    type: 'DIALOG',
    site: ['IDEEV', 'HM'],
    thematique: 'STORES',
    text: 'La nuit, en été, les volets et les stores à lames sont ouverts. Ce n’est pas le cas en hiver. La commande locale est désactivée.',
    background: 'img_bg_store1.jpg',
    characterImg: 'img_chr_sami1.png',
    characterName: 'Sami',
  },
  {
    id: 'rec2Fr60F3DDsKOov',
    order: 14,
    type: 'DIALOG',
    site: ['IDEEV'],
    thematique: 'ECLAIRAGES',
    text: 'Attention, vous pourriez vous retrouver dans le noir au moment de l’extinction du bâtiment à 20h. À ce moment, les activités ou déplacements dans le local peuvent engendrer des risques pour votre sécurité. Soyez donc prudents !​',
    characterImg: 'img_chr_eva1.png',
    characterName: 'Eva',
  },
  {
    id: 'rec2XhPaHqYZx0riW',
    order: 10,
    type: 'RECAP',
    site: ['IDEEV', 'HM'],
    thematique: 'CVC',
    text: 'Faire l’équilibre entre le confort et la sobriété énergétique, c’est notre challenge !',
    background: 'img_bg_cvc-regulateur.jpg',
    characterImg: 'img_miniature_cyril.png',
    characterName: 'Cyril',
    recap1:
      '#1 : Les thermostats sont réglés de manière optimale : on chauffe à 19 °C et on climatise à 26 °C',
    recap2:
      '#2 : Il est important de bien fermer les portes des salles et des laboratoires pour ne chauffer/climatiser que les espaces dédiés ',
    recap3: '#3 : Le bâtiment est branché sur un réseau de chaleur géothermie',
  },
  {
    id: 'rec2uR8zX7bGSBjBe',
    order: 11,
    type: 'DIALOG',
    site: ['IDEEV', 'HM'],
    thematique: 'STORES',
    text: 'Autre chose : si vous fermez les volets roulants complètement en plein hiver, vous risquez de surconsommer le chauffage et les éclairages artificiels… pas top pour la planète ! Le mode auto les bloque à 70%.​',
    background: 'img_bg_store1.jpg',
    characterImg: 'img_chr_sami1.png',
    image: 'img_bg_store2.jpg',
    characterName: 'Sami',
  },
  {
    id: 'rec3GYTQNbYx21VKE',
    order: 16,
    type: 'CLICK_IMAGE',
    site: ['IDEEV'],
    thematique: 'ECLAIRAGES',
    text: ' Comment contrôler la lumière dans cette salle de cours ? ',
    grilleCoords: 'D1, A3, D3',
    feedbackCorrect:
      'Bien vu !  ​Dans les petites salles de cours avec un tableau blanc, la lumière s’allume grâce à un détecteur de présence et une commande au tableau. ',
    feedbackIncorrect:
      'Dans les petites salles de cours avec un tableau blanc, la lumière s’allume grâce à un détecteur de présence et une commande au tableau. ',
    background: 'img_bg-laboratory.png',
    characterImg: 'img_miniature_eva.png',
    image: 'img_asset_photo-salle-cours.png',
    characterName: 'Eva',
  },
  {
    id: 'rec3PTzBwN9jKWwTz',
    order: 7,
    type: 'DIALOG_IMAGE',
    site: ['HM'],
    thematique: 'ASCENSEURS',
    text: 'A l’exception de ces <c2>deux ascenseurs mixtes</c2> qui fonctionnent toujours par badge…​',
    characterImg: 'img_miniature_alix.png',
    image: 'img_asset_44_ascenseur.png',
    characterName: 'Alix',
  },
  {
    id: 'rec3j6v0ZVDh25FUb',
    order: 8,
    type: 'QCU',
    site: ['IDEEV', 'HM'],
    thematique: 'CVC',
    text: 'Quelle est la température optimale pré réglée sur les thermostats en hiver ?​',
    answers: [
      {
        text: '15',
        isCorrect: false,
      },
      {
        text: '19',
        isCorrect: true,
      },
      {
        text: '23',
        isCorrect: false,
      },
      {
        text: '26',
        isCorrect: false,
      },
    ],
    feedbackCorrect:
      "Oui ! L'augmentation du chauffage de 1°C entraîne une surconsommation de 7%. ",
    feedbackIncorrect:
      "Attention L'augmentation du chauffage de 1°C entraîne une surconsommation de 7%. ",
    background: 'img_bg_cvc-regulateur.jpg',
    characterImg: 'img_miniature_cyril.png',
    characterName: 'Cyril',
  },
  {
    id: 'rec49addahiFRfSw2',
    order: 16,
    type: 'DIALOG_IMAGE',
    site: ['HM'],
    thematique: 'ASCENSEURS',
    text: 'Pour finir, vous trouverez un <c1>monte-personne</c1> dans chaque plot d’enseignement.',
    characterImg: 'img_miniature_alix.png',
    image: 'img_asset_53_ascenseur.png',
    characterName: 'Alix',
  },
  {
    id: 'rec4FWO2VuGImSnLu',
    order: 1,
    type: 'DIALOG',
    site: ['HM', 'IDEEV'],
    thematique: 'STORES',
    text: 'Bonjour, je suis Sami. Si vous êtes ici c’est pour parler des stores, c’est ça ? ',
    background: 'img_bg_store1.jpg',
    characterImg: 'img_chr_sami1.png',
    characterName: 'Sami',
  },
  {
    id: 'rec4M2HBi8unGKygH',
    order: 4,
    type: 'DIALOG_IMAGE',
    site: ['HM'],
    thematique: 'ECLAIRAGES',
    text: 'Dans certains bureaux, laboratoires ou certains locaux techniques, on retrouve des interrupteurs classiques et des boutons-poussoirs. Ces éclairages sont toujours positionnés près de la porte. ',
    background: 'img_bg_couloir.jpg',
    characterImg: 'img_miniature_eva.png',
    image: 'img_asset_interrupteur.png',
    characterName: 'Eva',
  },
  {
    id: 'rec5mUIWWnb0Ddiy4',
    order: 6,
    type: 'DIALOG_IMAGE',
    site: ['HM'],
    thematique: 'ASCENSEURS',
    text: 'Ici, c’est la zone logistique de Recherche. Il y a <c2>4 ascenseurs mixtes</c2> et <c1>1 ascenseur monte-personne</c1>.',
    characterImg: 'img_miniature_alix.png',
    image: 'img_asset_43_ascenseur.png',
    characterName: 'Alix',
  },
  {
    id: 'rec5mphJWnufVzbdU',
    order: 14,
    type: 'DIALOG',
    site: ['IDEEV', 'HM'],
    thematique: 'CONTROLS',
    text: 'Allez, voyons voir si vous avez tout compris !​',
    background: 'img_bg_porte-badge.jpg',
    characterImg: 'img_chr_carl2.png',
    characterName: 'Carl',
  },
  {
    id: 'rec64O2c8iRtRfdvu',
    order: 17,
    type: 'RECAP',
    site: ['IDEEV', 'HM'],
    thematique: 'CONTROLS',
    text: 'Il faut obligatoirement avoir son badge pour pouvoir circuler librement sur le site​',
    background: 'img_bg_porte-badge.jpg',
    characterImg: 'img_miniature_carl.png',
    characterName: 'Carl',
    recap1: '#1 : Il existe deux types de lecteurs : avec code et sans code.',
    recap2:
      '#2 : Les lecteurs ne sont pas actifs dans certaines zones, sur certains horaires.',
    recap3:
      '#3 : Toutes les zones ne sont pas accessibles à tout le monde. Certaines nécessitent des autorisations spécifiques.',
  },
  {
    id: 'rec69r8mYQFwl39Nm',
    order: 1,
    type: 'DIALOG',
    site: ['HM'],
    thematique: 'ASCENSEURS',
    text: "Bonjour, moi c’est Alix et mon dada, c'est les ascenseurs ! C'est moi qui les ai designés et je n'en suis pas peu fière. Devine combien on en a créé... et oui, pas moins de 20 en tout pour les deux sites ! ",
    background: 'img_bg_ascenceur.jpg',
    characterImg: 'img_chr_alix1.png',
    characterName: 'Alix',
  },
  {
    id: 'rec7Kwq3mSCriNtpH',
    order: 10,
    type: 'DIALOG',
    site: ['IDEEV', 'HM'],
    thematique: 'STORES',
    text: 'Ah, un conseil: pensez à bien fermer les fenêtres, sinon les stores vénitiens ne fonctionneront pas.',
    background: 'img_bg_store1.jpg',
    characterImg: 'img_chr_sami2.png',
    characterName: 'Sami',
  },
  {
    id: 'rec8YwmmJVaPwuhUX',
    order: 5,
    type: 'DIALOG_IMAGE',
    site: ['HM'],
    thematique: 'ASCENSEURS',
    text: 'Et bien sûr, de toujours privilégier les escaliers quand on le peut ! Question d’écologie !',
    background: 'img_bg_ascenceur.jpg',
    characterImg: 'img_miniature_alix.png',
    image: 'img_bg_escalier.jpg',
    characterName: 'Alix',
  },
  {
    id: 'rec8aS0RQ0yM8S992',
    order: 14,
    type: 'DIALOG',
    site: ['IDEEV', 'HM'],
    thematique: 'SORBONNES',
    text: '- N’utilisez pas de prises électriques non appropriées à l’intérieur de la sorbonne. Elles causent des surchauffes et peuvent provoquer des incendies. ​- N’utilisez pas la sorbonne comme dépôt de substances chimiques ou toxiques, dépourvues de protections adéquates.',
    background: 'img_bg_sorbonne2.jpg',
    characterImg: 'img_chr_sorbonne2.png',
    characterName: 'Sonia',
  },
  {
    id: 'rec8dT8yQBNIl6IJm',
    order: 15,
    type: 'DIALOG',
    site: ['IDEEV'],
    thematique: 'ECLAIRAGES',
    text: 'Retenez que sur nos deux sites, les éclairages ont été pensés pour être les plus adaptés possible aux pièces et à votre travail. Allez, voyons ce que vous avez retenu !​',
    background: 'img_bg-laboratory.png',
    characterImg: 'img_chr_eva2.png',
    characterName: 'Eva',
  },
  {
    id: 'rec9ArL0cmcm5U71z',
    order: 8,
    type: 'DIALOG',
    site: ['IDEEV', 'HM'],
    thematique: 'CONTROLS',
    text: 'Ce système de contrôle d’accès et de détection d’intrusion est destiné à limiter et gérer les autorisations des personnes aux différentes zones du bâtiment.​',
    background: 'img_bg_porte-badge.jpg',
    characterImg: 'img_chr_carl2.png',
    characterName: 'Carl',
  },
  {
    id: 'recC46NETu9lvmB40',
    order: 7,
    type: 'DIALOG',
    site: ['IDEEV', 'HM'],
    thematique: 'STORES',
    text: 'On appelle ça le shadow-management. S’il n’y a pas de soleil, les stores se placent en position haute. ',
    background: 'img_bg_store1.jpg',
    characterImg: 'img_chr_sami1.png',
    characterName: 'Sami',
  },
  {
    id: 'recClVkADPcXHTOWu',
    order: 22,
    type: 'RECAP',
    site: ['HM'],
    thematique: 'ASCENSEURS',
    text: 'Vous pouvez retenir qu’il y a 16 ascenseurs sur le site Henri Moissan avec plusieurs particularités : ',
    background: 'img_bg_ascenceur.jpg',
    characterImg: 'img_miniature_alix.png',
    characterName: 'Alix',
    recap1:
      '#1 : 2 types : monte personne et ascenseur mixte (monte charge et monte personne)',
    recap2:
      '#2 : Privilégiez les escaliers si vous le pouvez ! Question d’économie d’énergie !',
    recap3:
      '#3 : Possibilité de transporter de l’azote avec un accès particulier et une procédure à suivre.',
  },
  {
    id: 'recD2X2rj7TtFgSOn',
    order: 8,
    type: 'DIALOG',
    site: ['IDEEV', 'HM'],
    thematique: 'STORES',
    text: 'A noter que le mode AUTOMATIQUE est activé de 7h à 20h.',
    background: 'img_bg_store1.jpg',
    characterImg: 'img_chr_sami2.png',
    characterName: 'Sami',
  },
  {
    id: 'recDhb2Nzacu55p1C',
    order: 2,
    type: 'DIALOG',
    site: ['IDEEV', 'HM'],
    thematique: 'STORES',
    text: 'Ne perdons pas de temps et entrons dans le vif du sujet. il y a deux types de stores : ​Les stores types vénitiens ',
    background: 'img_bg_store1.jpg',
    characterImg: 'img_chr_sami2.png',
    characterName: 'Sami',
  },
  {
    id: 'recEDB8XbK4jZzcCc',
    order: 9,
    type: 'DRAG_DROP',
    site: ['IDEEV', 'HM'],
    thematique: 'CVC',
    text: 'Que faut-il faire pour garder les espaces chauffés ou climatisés de manière optimale ?​',
    answers: [
      {
        text: 'Ne pas modifier les pré réglages sur les thermostats',
        isCorrect: true,
      },
      {
        text: 'Bien fermer les portes des salles',
        isCorrect: true,
      },
      {
        text: 'Ouvrir la fenêtre​',
        isCorrect: false,
      },
    ],
    feedbackCorrect: 'C’est ça ! ',
    feedbackIncorrect:
      'Il est préconisé pour maintenir les espaces chauffés et climatisés de manière optimale de ne pas modifier les pré réglages et de bien fermer les portes des salles.',
    background: 'img_bg_cvc-regulateur.jpg',
    characterImg: 'img_miniature_cyril.png',
    characterName: 'Cyril',
  },
  {
    id: 'recEQUyRhqlug5rc4',
    order: 2,
    type: 'DIALOG',
    site: ['HM'],
    thematique: 'ECLAIRAGES',
    text: 'Laissez-moi vous apporter mes lumières!​ Dans nos deux sites, nous avons une quinzaine de types d’éclairage. Certains sont à commande locale, ça veut dire qu’elle est située dans ou à proximité du local, alors que d’autres sont automatiques.',
    background: 'img_bg_couloir.jpg',
    characterImg: 'img_chr_eva2.png',
    characterName: 'Eva',
  },
  {
    id: 'recEacvUm6bd11HXy',
    order: 13,
    type: 'DIALOG_IMAGE',
    site: ['IDEEV', 'HM'],
    thematique: 'CONTROLS',
    text: 'Enfin, en cas d’évacuation, utilisez les Boitiers Brise-Glace verts pour ouvrir les portes d’évacuation.​',
    background: 'img_bg_porte-badge.jpg',
    characterImg: 'img_miniature_carl.png',
    image: 'img_asset_boitier-brise-glace.png',
    characterName: 'Carl',
  },
  {
    id: 'recFkhoNrLeZMDrFS',
    order: 1,
    type: 'DIALOG',
    site: ['IDEEV'],
    thematique: 'ASCENSEURS',
    text: "Bonjour, moi c’est Alix et mon dada, c'est les ascenseurs ! C'est moi qui les ai designés et je n'en suis pas peu fière. Devinez combien on en a créé... et oui, pas moins de 20 en tout pour les deux sites ! ",
    background: 'img_bg_ascenceur.jpg',
    characterImg: 'img_chr_alix1.png',
    characterName: 'Alix',
  },
  {
    id: 'recFrSGs6vrgxZIZg',
    order: 9,
    type: 'DIALOG',
    site: ['IDEEV'],
    thematique: 'ECLAIRAGES',
    text: 'Dans les salles de cours, de TD et les bureaux, les sources lumineuses peuvent être graduées. Ce mode reste actif tant que le détecteur détecte une présence. Dans le cas contraire il repassera en mode automatique.',
    background: 'img_bg-laboratory.png',
    characterImg: 'img_chr_eva1.png',
    characterName: 'Eva',
  },
  {
    id: 'recG1yoXbC70oACak',
    order: 18,
    type: 'DIALOG',
    site: ['HM'],
    thematique: 'ASCENSEURS',
    text: 'Voyons voir si mes explications étaient claires !​',
    background: 'img_bg_ascenceur.jpg',
    characterImg: 'img_chr_alix2.png',
    characterName: 'Alix',
  },
  {
    id: 'recG5FwNklTch1tXa',
    order: 9,
    type: 'DIALOG_IMAGE',
    site: ['IDEEV', 'HM'],
    thematique: 'SORBONNES',
    text: 'Ici, vous pouvez voir que le voyant de l’alarme est activé. Quand c’est le cas, tu entendras aussi un « Bip ». Cela signifie qu’il y a un risque pour l’opérateur car présence d’un problème technique.',
    characterImg: 'img_miniature_sorbonne.png',
    image: 'img_bg_sorbonne-commande.jpg',
    characterName: 'Sonia',
  },
  {
    id: 'recHtNYHoO8ckBXXD',
    order: 19,
    type: 'DRAG_DROP',
    site: ['HM'],
    thematique: 'ASCENSEURS',
    text: 'Dans quels secteurs trouverez-vous des ascenseurs mixtes ? ​',
    answers: [
      {
        text: 'Zone centrale Recherche',
        isCorrect: true,
      },
      {
        text: 'Zone Est Galeria',
        isCorrect: false,
      },
      {
        text: 'Bâtiment du CROUS',
        isCorrect: false,
      },
      {
        text: 'Zone logistique Sud Recherche',
        isCorrect: true,
      },
    ],
    feedbackCorrect:
      'Dans quels secteurs trouverez-vous des ascenseurs mixtes ? ​',
    feedbackIncorrect:
      'Vous avez la possibilité d’emprunter 6 ascenseurs pour monter du matériel. Ils sont présents dans chaque zone. Par contre dans la zone Est Galeria, vous ne trouverez que des monte-personnes. ',
    background: 'img_bg_ascenceur.jpg',
    characterImg: 'img_miniature_alix.png',
    characterName: 'Alix',
  },
  {
    id: 'recHvZqeIpEm8etWC',
    order: 20,
    type: 'QCU',
    site: ['HM'],
    thematique: 'ASCENSEURS',
    text: 'Pouvez-vous transporter de l’azote dans les ascenseurs mixtes ?',
    answers: [
      {
        text: 'OUI',
        isCorrect: true,
      },
      {
        text: 'NON',
        isCorrect: false,
      },
    ],
    feedbackCorrect:
      "C'est ça, et c’est possible de le faire sans transport de personnel, grâce à une clé et une procédure spécifique qui inhibe toute autre commande.",
    background: 'img_bg_ascenceur.jpg',
    characterImg: 'img_miniature_alix.png',
    characterName: 'Alix',
  },
  {
    id: 'recI1tcXgVVytU9Ck',
    order: 7,
    type: 'DIALOG',
    site: ['IDEEV', 'HM'],
    thematique: 'CVC',
    text: 'Enfin, sachez que le bâtiment est branché sur un réseau de chaleur géothermique et qu’en plus il y a un système de secours avec des chaudières ! Tout est prévu !​',
    background: 'img_bg_cvc-regulateur.jpg',
    characterImg: 'img_chr_cyril1.png',
    characterName: 'Cyril',
  },
  {
    id: 'recI26H2jr7ZdgPmf',
    order: 2,
    type: 'DIALOG',
    site: ['IDEEV', 'HM'],
    thematique: 'CONTROLS',
    text: 'Je rigole ! Moi c’est Carl, spécialiste des contrôles d’accès.',
    background: 'img_bg_porte-badge.jpg',
    characterImg: 'img_chr_carl2.png',
    characterName: 'Carl',
  },
  {
    id: 'recI3nrh8F8MGfl7q',
    order: 18,
    type: 'CLICK_IMAGE',
    site: ['IDEEV', 'HM'],
    thematique: 'SORBONNES',
    text: "Sur l’image suivante, cliquez sur les éléments à vérifier  à la fin de l’utilisation d'une sorbonne",
    grilleCoords: 'D1, A2, B2, C2, D2, A3, B3, C3',
    feedbackCorrect:
      "Parfait ! ​Effectivement…il est indispensable de vérifier qu'aucun objet ne soit entreposé sous la vitre de la Sorbonne, les éléments translucides peuvent ne pas être détectés par l'infrarouge.  Remettre en mode automatique pour réduire la consommation d'énergie.",
    feedbackIncorrect:
      "Il est indispensable de vérifier qu'aucun objet ne soit entreposé sous la vitre de la Sorbonne, les éléments translucides peuvent ne pas être détectés par l'infrarouge.  Remettre en mode automatique pour réduire la consommation d'énergie.",
    background: 'img_bg_sorbonne2.jpg',
    characterImg: 'img_miniature_sorbonne.png',
    image: 'img_asset_sorbonne_quiz_without-line.png',
    characterName: 'Sonia',
  },
  {
    id: 'recI8wWNlYTWTDJMf',
    order: 8,
    type: 'DIALOG',
    site: ['IDEEV', 'HM'],
    thematique: 'SORBONNES',
    text: 'Regardons ensemble le tableau de commande.',
    background: 'img_bg_sorbonne1.jpg',
    characterImg: 'img_chr_sorbonne1.png',
    characterName: 'Sonia',
  },
  {
    id: 'recIsnEnbu4RYfybu',
    order: 5,
    type: 'DIALOG_IMAGE',
    site: ['IDEEV'],
    thematique: 'ASCENSEURS',
    text: 'Il y en a 5 en tout : <c1>3 ascenseurs monte-personnes</c1> à l’entrée du bâtiment, et <c2>2 ascenseurs mixtes</c2> au premier étage (donc pour le matériel et les personnes).',
    characterImg: 'img_miniature_alix.png',
    image: 'img_asset_28_ascenseur.png',
    characterName: 'Alix',
  },
  {
    id: 'recK3ITF2OFGKGwUF',
    order: 17,
    type: 'DRAG_DROP',
    site: ['IDEEV', 'HM'],
    thematique: 'SORBONNES',
    text: 'Que faut-il faire avant d’utiliser la sorbonne ? ',
    answers: [
      {
        text: 'S’assurer que le voyant est vert',
        isCorrect: true,
      },
      {
        text: 'Vérifier la commande auto/ manuel',
        isCorrect: true,
      },
      {
        text: 'Vérifier l’organisation du plan de travail par rapport à la guillotine',
        isCorrect: true,
      },
      {
        text: 'Tester l’ensemble des boutons',
        isCorrect: false,
      },
    ],
    feedbackCorrect:
      "Bien vu ! ​Vous devez contrôler plusieurs éléments avant le démarrage de la sorbonne comme le résultat de l'essai par le technicien, l'installation, le plan de travail, le sens de rotation des motorisations...",
    feedbackIncorrect:
      "Vous devez contrôler plusieurs éléments avant le démarrage de la sorbonne comme le résultat de l'essai par le technicien, l'installation, le plan de travail, le sens de rotation des motorisations...",
    background: 'img_bg_sorbonne2.jpg',
    characterImg: 'img_miniature_sorbonne.png',
    characterName: 'Sonia',
  },
  {
    id: 'recK9bZsBx1APml5x',
    order: 15,
    type: 'FRISE',
    site: ['IDEEV', 'HM'],
    thematique: 'STORES',
    text: 'Les horaires du mode automatique sont-ils modifiables ? ',
    answers: [
      {
        text: 'Oui par tout le monde',
        isCorrect: false,
      },
      {
        text: 'Oui par le service technique​',
        isCorrect: true,
      },
      {
        text: 'Oui par le directeur du site​',
        isCorrect: false,
      },
      {
        text: 'Non c’est trop tard​',
        isCorrect: false,
      },
    ],
    feedbackCorrect:
      'Super ! ​Seul le service peut changer les heures et dates du mode automatique. En revanche, vous pouvez utiliser le mode manuel entre 7h et 20h (ou 22h en été) pour adapter vos stores ou volets roulants.',
    feedbackIncorrect:
      'Seuls le service peut changer les heures et dates du mode automatique. En revanche, vous pouvez utiliser le mode manuel entre 7h et 20h (ou 22h en été) pour adapter vos stores ou volets roulants.',
    background: 'img_bg_store1.jpg',
    characterImg: 'img_miniature_sami.png',
    characterName: 'Sami',
  },
  {
    id: 'recKfFCR1qgj8mNcU',
    order: 6,
    type: 'DIALOG',
    site: ['IDEEV', 'HM'],
    thematique: 'STORES',
    text: "Le jour, les volets et les stores sont pilotés en fonction de l'ensoleillement de la façade et des ombres portés. La position des stores est mise à jour toutes les 10 minutes.​",
    background: 'img_bg_store1.jpg',
    characterImg: 'img_chr_sami2.png',
    characterName: 'Sami',
  },
  {
    id: 'recKrs2O6XQMmCJro',
    order: 4,
    type: 'DIALOG',
    site: ['IDEEV', 'HM'],
    thematique: 'CVC',
    text: 'Rappelez-vous qu’il est important de bien fermer les portes des salles et des laboratoires pour ne chauffer ou climatiser que l’espace dédié. On recherche la sobriété énergétique et on compte sur vous !',
    background: 'img_bg_cvc-regulateur.jpg',
    characterImg: 'img_chr_cyril2.png',
    characterName: 'Cyril',
  },
  {
    id: 'recLHjhHTpCqFijCR',
    order: 13,
    type: 'DIALOG_IMAGE',
    site: ['HM'],
    thematique: 'ECLAIRAGES',
    text: 'Pour les amphithéâtres du site Henri Moissan, il y a  des détecteurs de présence : l’allumage est automatique. Il est également possible de modifier la luminosité via des commandes sur la tablette connectée en pupitre. ​',
    background: 'img_bg_couloir.jpg',
    characterImg: 'img_miniature_eva.png',
    image: 'img_asset_emphitheatre.png',
    characterName: 'Eva',
  },
  {
    id: 'recLSgQotMcOHD2ym',
    order: 10,
    type: 'DIALOG_IMAGE',
    site: ['IDEEV', 'HM'],
    thematique: 'CONTROLS',
    text: "Lorsque vous êtes à l'intérieur des bâtiments de Henri Moissan et IDEEV les boutons avec une clés vous permettent de déverrouiller  les portes pour sortir.​",
    background: 'img_bg_porte-badge.jpg',
    characterImg: 'img_miniature_carl.png',
    image: 'img_asset_btn-cles.png',
    characterName: 'Carl',
  },
  {
    id: 'recLkrFbmzmPvkzr4',
    order: 19,
    type: 'RECAP',
    site: ['IDEEV'],
    thematique: 'ECLAIRAGES',
    text: 'Sur les sites Ideev et Henri Moissan, il y a une quinzaine de types d’éclairage avec des particularités : ​',
    background: 'img_bg-laboratory.png',
    characterImg: 'img_miniature_eva.png',
    characterName: 'Eva',
    recap1:
      '#1 : 3 grandes familles : interrupteur, bouton-poussoir, détecteur de présence',
    recap2:
      '#2 : Les pièces avec des détecteurs de présence ont aussi des boutons pour réguler la lumière de façon autonome.',
    recap3:
      '#3 : Pour les pièces avec des boutons poussoirs, pensez à bien éteindre lorsque vous partez',
  },
  {
    id: 'recLqdKWJSz1w15Ge',
    order: 4,
    type: 'DIALOG_IMAGE',
    site: ['IDEEV', 'HM'],
    thematique: 'STORES',
    text: "Une commande locale est présente dans les différentes pièces.​Un appui long fait monter ou descendre les volets et les stores. Un appui court change l'orientation des lames.",
    background: 'img_bg_store1.jpg',
    characterImg: 'img_miniature_sami.png',
    image: 'img_asset_commande-locale.png',
    characterName: 'Sami',
  },
  {
    id: 'recMyy2iKN9gumm1b',
    order: 10,
    type: 'DIALOG',
    site: ['IDEEV'],
    thematique: 'ASCENSEURS',
    text: 'Ok, c’est tout pour moi. J’espère avoir été rapide et assez claire ? ​Voyons voir ça !',
    background: 'img_bg_ascenceur.jpg',
    characterImg: 'img_chr_alix1.png',
    characterName: 'Alix',
  },
  {
    id: 'recN1OqPs28P5ymbe',
    order: 11,
    type: 'DIALOG_IMAGE',
    site: ['IDEEV', 'HM'],
    thematique: 'SORBONNES',
    text: "Il faut s'assurer que le voyant vert est toujours allumé. Les sorbonnes doivent toujours être allumées.",
    characterImg: 'img_miniature_sorbonne.png',
    image: 'img_bg_sorbonne-commande.jpg',
    characterName: 'Sonia',
  },
  {
    id: 'recNZ1AMSdwvVMDNG',
    order: 8,
    type: 'DIALOG_IMAGE',
    site: ['HM'],
    thematique: 'ASCENSEURS',
    text: '… les 3 autres ascenseurs au rez-de-chaussée et 4ème et 5ème étage sont en libre accès !',
    characterImg: 'img_miniature_alix.png',
    image: 'img_asset_45_ascenseur.png',
    characterName: 'Alix',
  },
  {
    id: 'recNdMHSLPTixPXby',
    order: 15,
    type: 'DIALOG',
    site: ['HM'],
    thematique: 'ECLAIRAGES',
    text: 'Retenez que sur nos deux sites, les éclairages ont été pensés pour être les plus adaptés possible aux pièces et à votre travail. Allez, voyons ce que vous avez retenu !​',
    background: 'img_bg_couloir.jpg',
    characterImg: 'img_chr_eva2.png',
    characterName: 'Eva',
  },
  {
    id: 'recNlNVsNeHSWWPpf',
    order: 12,
    type: 'DIALOG_IMAGE',
    site: ['HM'],
    thematique: 'ECLAIRAGES',
    text: "Dans les salles de cours il est possible d'inhiber le détecteur de présence afin de forcer l'extinction des lumières (par exemple pour une projection). Pour cela, un système de commande à clé existe et se situe à l'entrée de la salle. ​",
    background: 'img_bg_couloir.jpg',
    characterImg: 'img_miniature_eva.png',
    image: 'img_asset_commande-cle.png',
    characterName: 'Eva',
  },
  {
    id: 'recNzmFotylTbj4qy',
    order: 4,
    type: 'DIALOG_IMAGE',
    site: ['HM'],
    thematique: 'ASCENSEURS',
    text: 'Voici la carte complète des ascenseurs du site Henri Moissan. Tu vois qu’on y trouve 2 sortes d’ascenseurs : des <c1>monte-personnes</c1> et des <c2>ascenseurs mixtes</c2> (monte personne + monte-charge). L’idée est de respecter leur utilité propre afin d’optimiser leur fonctionnement.',
    characterImg: 'img_miniature_alix.png',
    image: 'img_asset_41_ascenseur.png',
    characterName: 'Alix',
  },
  {
    id: 'recOEeefMlZgw2s8m',
    order: 9,
    type: 'DIALOG_IMAGE',
    site: ['IDEEV', 'HM'],
    thematique: 'CONTROLS',
    text: 'L’accès au site se fait nécessairement avec des règles d’identification individuelle. Chaque personne qui se voit attribué un badge en possède un qui lui est propre.​',
    background: 'img_bg_porte-badge.jpg',
    characterImg: 'img_miniature_carl.png',
    image: 'img_asset_badge-ascenseur-ext-carte.png',
    characterName: 'Carl',
  },
  {
    id: 'recOjodk5Ypgf5n0z',
    order: 17,
    type: 'DIALOG_IMAGE',
    site: ['HM'],
    thematique: 'ASCENSEURS',
    text: 'Voici la carte résumée et complète ! Prends ton temps pour la visualiser avant de passer au test.​',
    characterImg: 'img_miniature_alix.png',
    image: 'img_asset_54_ascenseur.png',
    characterName: 'Alix',
  },
  {
    id: 'recOy3gdhTB2bK9ou',
    order: 1,
    type: 'DIALOG',
    site: ['HM'],
    thematique: 'ECLAIRAGES',
    text: 'Bonjour, je suis Eva.​ Vous êtes ici pour l’éclairage, c’est bien ça ?​<br />Pour information les éclairages représentent environ 6% des consommations de ce bâtiment. ',
    background: 'img_bg_couloir.jpg',
    characterImg: 'img_chr_eva1.png',
    characterName: 'Eva',
  },
  {
    id: 'recPVYy19trUGP450',
    order: 18,
    type: 'DRAG_DROP',
    site: ['IDEEV'],
    thematique: 'ECLAIRAGES',
    text: 'Quel est le fonctionnement de l’éclairage des couloirs ?',
    answers: [
      {
        text: 'Sur seuil de luminosité​',
        isCorrect: true,
      },
      {
        text: 'Fonctionnement 1/3 – 2/3​',
        isCorrect: true,
      },
      {
        text: 'Sur interrupteur​',
        isCorrect: false,
      },
      {
        text: 'Avec jeu de clé​',
        isCorrect: false,
      },
    ],
    feedbackCorrect:
      'C’est ça ! Leur fonctionnement est particulier : ils fonctionnent en 1/3 – 2/3. C’est-à-dire qu’il y a plusieurs luminaires et que seul 1/3 sont programmés pour rester allumés constamment. ',
    feedbackIncorrect:
      'Leur fonctionnement est particulier : ils fonctionnent en 1/3 – 2/3. C’est-à-dire qu’il y a plusieurs luminaires et que seul 1/3 sont programmés pour rester allumés constamment. ',
    background: 'img_bg-laboratory.png',
    characterImg: 'img_miniature_eva.png',
    characterName: 'Eva',
  },
  {
    id: 'recR3HqJW4vkDrhXw',
    order: 3,
    type: 'DIALOG',
    site: ['IDEEV', 'HM'],
    thematique: 'CONTROLS',
    text: 'La première chose à savoir sur ce sujet c’est que vous n’irez nulle part sans badge lors des heures d’activation des lecteurs !',
    background: 'img_bg_porte-badge.jpg',
    characterImg: 'img_chr_carl1.png',
    characterName: 'Carl',
  },
  {
    id: 'recRMMHKbA9bQsfFM',
    order: 5,
    type: 'DIALOG_IMAGE',
    site: ['HM'],
    thematique: 'ECLAIRAGES',
    text: 'Ensuite, nous avons des détecteurs de présence qui allument la pièce pendant minimum 15 minutes. En fonction de l’agencement de la pièce, ils sont au plafond ou au mur, tous les 10m environ.  ',
    background: 'img_bg_couloir.jpg',
    characterImg: 'img_miniature_eva.png',
    image: 'img_asset_detecteur-presence.png',
    characterName: 'Eva',
  },
  {
    id: 'recRyAlOwUJdAkpPe',
    order: 10,
    type: 'DIALOG_IMAGE',
    site: ['HM'],
    thematique: 'ECLAIRAGES',
    text: 'Certaines salles de cours sont équipées de Tableaux Blancs. ​',
    background: 'img_bg_couloir.jpg',
    characterImg: 'img_miniature_eva.png',
    image: 'img_asset_photo-salle-cours.png',
    characterName: 'Eva',
  },
  {
    id: 'recSPueHNsPGgmtWa',
    order: 14,
    type: 'DIALOG_IMAGE',
    site: ['HM'],
    thematique: 'ASCENSEURS',
    text: 'Vous trouverez des informations concernant les ascenseurs sur les affiches accrochées, à côté des panneaux. Quels étages ils desservent, s’il est necessaire d’utiliser un badge, etc…​',
    background: 'img_bg_ascenceur.jpg',
    characterImg: 'img_miniature_alix.png',
    image: 'img_bg_mur-ascenseur.jpg',
    characterName: 'Alix',
  },
  {
    id: 'recSTTLMEjzpzUpzT',
    order: 5,
    type: 'DIALOG_IMAGE',
    site: ['IDEEV'],
    thematique: 'ECLAIRAGES',
    text: 'Ensuite, nous avons des détecteurs de présence qui allument la pièce pendant minimum 15 minutes. En fonction de l’agencement de la pièce, ils sont au plafond ou au mur, tous les 10 mètres environ.  ',
    background: 'img_bg-laboratory.png',
    characterImg: 'img_miniature_eva.png',
    image: 'img_asset_detecteur-presence.png',
    characterName: 'Eva',
  },
  {
    id: 'recSeEnx9BE9Du2x3',
    order: 12,
    type: 'DIALOG_IMAGE',
    site: ['IDEEV'],
    thematique: 'ECLAIRAGES',
    text: "Dans les salles de cours il est possible d'inhiber le détecteur de présence afin de forcer l'extinction des lumières (par exemple pour une projection). Pour cela, un système de commande à clé existe et se situe à l'entrée de la salle. ​",
    background: 'img_bg-laboratory.png',
    characterImg: 'img_miniature_eva.png',
    image: 'img_asset_commande-cle.png',
    characterName: 'Eva',
  },
  {
    id: 'recSopeAQD8kF3hem',
    order: 13,
    type: 'DIALOG',
    site: ['IDEEV', 'HM'],
    thematique: 'SORBONNES',
    text: 'Je pense qu’on a balayé l’ensemble des informations à connaître pour utiliser une sorbonne de façon optimale et en sécurité. Lors de son utilisation, vous êtes responsables et devez veiller aux règles de sécurité. Ça peut vous sembler logique mais un petit rappel ne fait jamais de mal.',
    background: 'img_bg_sorbonne2.jpg',
    characterImg: 'img_chr_sorbonne1.png',
    characterName: 'Sonia',
  },
  {
    id: 'recSybS8mei0mFcOE',
    order: 3,
    type: 'DIALOG',
    site: ['IDEEV', 'HM'],
    thematique: 'SORBONNES',
    text: 'Et bien  le rôle d’une sorbonne est de confiner les fumées, les gaz toxiques et les vapeurs dangereuses grâce à sa guillotine qui s’ouvre et se ferme. D’ailleurs les sorbonnes sont toujours fermées quand personne ne travaille dessus : c’est indispensable. Question de sécurité et d’économie d’énergie !',
    background: 'img_bg_sorbonne1.jpg',
    characterImg: 'img_chr_sorbonne1.png',
    characterName: 'Sonia',
  },
  {
    id: 'recTlOt4HaYUlCrCr',
    order: 8,
    type: 'DIALOG',
    site: ['IDEEV'],
    thematique: 'ECLAIRAGES',
    text: 'Le fonctionnement est particulier : les éclairages fonctionnent en 1/3 – 2/3. C’est-à-dire qu’il y a plusieurs luminaires et que seul 1/3 sont programmés pour rester allumés constamment.',
    background: 'img_bg-laboratory.png',
    characterImg: 'img_chr_eva2.png',
    characterName: 'Eva',
  },
  {
    id: 'recUC6FKfV04jicvo',
    order: 15,
    type: 'DIALOG',
    site: ['IDEEV', 'HM'],
    thematique: 'SORBONNES',
    text: '- Ne gardez sous la sorbonne que le matériel nécessaire à la tâche.<br />- Ne bouchez pas le passage de l’air le long du plan de la sorbonne. ​<br />Et puis n’oubliez pas qu’en cas de doutes ou de problèmes, le Service Technique reste à votre disposition. ',
    background: 'img_bg_sorbonne2.jpg',
    characterImg: 'img_chr_sorbonne1.png',
    characterName: 'Sonia',
  },
  {
    id: 'recULdkobz8Kwwda0',
    order: 2,
    type: 'DIALOG',
    site: ['HM'],
    thematique: 'ASCENSEURS',
    text: 'C’est sur le site Henri Moissan qu’il y en a le plus. 16 en tout ! Ici, leur consommation totale est de 45kWh par mois. En 2023, ils représentent 11 MWh, soit la consommation moyenne annuelle de 57 machines à laver !',
    background: 'img_bg_ascenceur.jpg',
    characterImg: 'img_chr_alix2.png',
    characterName: 'Alix',
  },
  {
    id: 'recUWC9TMNKmsZFHu',
    order: 6,
    type: 'DIALOG_IMAGE',
    site: ['IDEEV', 'HM'],
    thematique: 'SORBONNES',
    text: "En fait, si vous êtes en manuel, n’oubliez pas de repasser en automatique en quittant la sorbonne tout en faisant attention à ce qu'il n’y ait pas de produit à la limite du bord. Le laser ne détecte pas les produits transparents ! ",
    characterImg: 'img_miniature_sorbonne.png',
    image: 'img_bg_sorbonne1.jpg',
    characterName: 'Sonia',
  },
  {
    id: 'recUoNd9vCZbEbJCy',
    order: 5,
    type: 'DIALOG_IMAGE',
    site: ['IDEEV', 'HM'],
    thematique: 'CVC',
    text: 'Pour les thermostats, ils fonctionnent simplement. Il vous suffit de tourner la molette pour obtenir la température souhaitée au niveau de la flèche. On vous préconise de les laisser réglés sur 19°C ou hors-gel en période d’absence.',
    background: 'img_bg_cvc-regulateur.jpg',
    characterImg: 'img_miniature_cyril.png',
    image: 'img_asset_thermostat1.png',
    characterName: 'Cyril',
  },
  {
    id: 'recVIM5r1pMUpsrJd',
    order: 12,
    type: 'DIALOG_IMAGE',
    site: ['HM'],
    thematique: 'ASCENSEURS',
    text: 'Dans la zone centrale Galeria, <c1>6</c1> sur 7 ascenseurs sont des <c1>monte-personnes</c1>. Le dernier est <c2>mixte</c2> et…​',
    characterImg: 'img_miniature_alix.png',
    image: 'img_asset_49_ascenseur.png',
    characterName: 'Alix',
  },
  {
    id: 'recWiaeYqgMcaGVVQ',
    order: 10,
    type: 'DIALOG_IMAGE',
    site: ['IDEEV', 'HM'],
    thematique: 'SORBONNES',
    text: 'Ici, plusieurs boutons sont importants : ​   les voyants de contrôle, ​l’arrêt alarme, ​le voyant lumière à arrêter.  L’allumage et l’arrêt ont été inhibés par mesure de sécurité.',
    characterImg: 'img_miniature_sorbonne.png',
    image: 'img_bg_sorbonne-commande.jpg',
    characterName: 'Sonia',
  },
  {
    id: 'recZNPynmdNSunNco',
    order: 3,
    type: 'DIALOG',
    site: ['IDEEV', 'HM'],
    thematique: 'STORES',
    text: 'Et les volets roulants. ​Ils ont deux modes de fonctionnements : manuel et automatique. Jusque-là vous me suivez ? ',
    background: 'img_bg_store1.jpg',
    characterImg: 'img_chr_sami1.png',
    image: 'img_bg_store2.jpg',
    characterName: 'Sami',
  },
  {
    id: 'recZWOirgzDjBqhjs',
    order: 5,
    type: 'DIALOG',
    site: ['IDEEV', 'HM'],
    thematique: 'CONTROLS',
    text: 'Les badges permettent d’accéder à l’ensemble des locaux programmés au sein du site, étant entendu qu’ils disposent de différents niveaux d’autorisation d’accès.​',
    background: 'img_bg_porte-badge.jpg',
    characterImg: 'img_chr_carl1.png',
    characterName: 'Carl',
  },
  {
    id: 'recZZzXLsNri5fVPP',
    order: 11,
    type: 'DIALOG',
    site: ['IDEEV', 'HM'],
    thematique: 'CONTROLS',
    text: 'Ah oui, un point important : assurez-vous que les portes soient correctement fermées le soir sinon l’utilité du badge est perdue !​',
    background: 'img_bg_porte-badge.jpg',
    characterImg: 'img_chr_carl1.png',
    characterName: 'Carl',
  },
  {
    id: 'recZwE51rWbizdoCx',
    order: 17,
    type: 'QCM',
    site: ['HM'],
    thematique: 'ECLAIRAGES',
    text: 'Dans quelle pièce devez-vous faire attention à la coupure automatique avant 7h et après 20h du lundi au samedi matin ? ',
    answers: [
      {
        text: 'Salle de cours',
        isCorrect: true,
      },
      {
        text: 'Le local de zone de laboratoire',
        isCorrect: true,
      },
      {
        text: 'L’amphithéâtre',
        isCorrect: true,
      },
      {
        text: 'Le couloir',
        isCorrect: true,
      },
    ],
    feedbackCorrect:
      "Oui ! ​Ici toutes les réponses sont bonnes, car à 20h tout s'éteint et passe en allumage sur détection de mouvement.",
    feedbackIncorrect:
      "Ici toutes les réponses sont bonnes, car à 20h tout s'éteint et passe en allumage sur détection de mouvement.",
    background: 'img_bg_couloir.jpg',
    characterImg: 'img_miniature_eva.png',
    characterName: 'Eva',
  },
  {
    id: 'recaMWU5XCrLPF2u2',
    order: 5,
    type: 'DIALOG_IMAGE',
    site: ['IDEEV', 'HM'],
    thematique: 'SORBONNES',
    text: 'Le bouton de droite sert à enclencher le mode automatique pour la fermeture de la guillotine. C’est bien pratique car les sorbonnes sont alimentées 24h/24. En mode manuel, on peut toujours craindre un oubli ! ',
    characterImg: 'img_miniature_sorbonne.png',
    image: 'img_bg_sorbonne1.jpg',
    characterName: 'Sonia',
  },
  {
    id: 'recbsAL4VtxvfLxyL',
    order: 15,
    type: 'DIALOG_IMAGE',
    site: ['HM'],
    thematique: 'ASCENSEURS',
    text: 'Enfin, sachez que tous ces ascenseurs vous emmènent à l’amphithéatre de 200 places et ceux en bleus à l’amphithéatre de 400 places.',
    characterImg: 'img_miniature_alix.png',
    image: 'img_asset_52_ascenseur.png',
    characterName: 'Alix',
  },
  {
    id: 'reccH72PGubjsN1bx',
    order: 16,
    type: 'QCU',
    site: ['IDEEV', 'HM'],
    thematique: 'CONTROLS',
    text: 'En cas d’oubli, je peux utiliser le badge d’un pair pour circuler.',
    answers: [
      {
        text: 'VRAI',
        isCorrect: false,
      },
      {
        text: 'FAUX',
        isCorrect: true,
      },
    ],
    feedbackCorrect:
      "Le badge est attribué à une personne spécifique avec des droits d'accès personnalisés. ​",
    feedbackIncorrect:
      "Le badge est attribué à une personne spécifique avec des droits d'accès personnalisés. ​",
    background: 'img_bg_porte-badge.jpg',
    characterImg: 'img_miniature_carl.png',
    characterName: 'Carl',
  },
  {
    id: 'reccjVAQwwPy7maLS',
    order: 6,
    type: 'DIALOG_IMAGE',
    site: ['IDEEV'],
    thematique: 'ASCENSEURS',
    text: '<c2>Ces ascenseurs</c2>, spécifiquement, autorisent le transport d’azote et autre gaz sans nécessité qu’il y ait du personnel accompagnant. Pour en savoir plus, vous pouvez vous rapprocher de l’assistant de prévention.​',
    characterImg: 'img_miniature_alix.png',
    image: 'img_asset_29_ascenseur.png',
    characterName: 'Alix',
  },
  {
    id: 'rece0rmmIc1Sbv7AC',
    order: 2,
    type: 'DIALOG',
    site: ['IDEEV', 'HM'],
    thematique: 'SORBONNES',
    text: 'Commençons par le début. A quoi servent-elles ?',
    background: 'img_bg_sorbonne1.jpg',
    characterImg: 'img_chr_sorbonne2.png',
    characterName: 'Sonia',
  },
  {
    id: 'rece34w3WrHKYRKUb',
    order: 6,
    type: 'DIALOG_IMAGE',
    site: ['IDEEV', 'HM'],
    thematique: 'CVC',
    text: 'Il existe aussi un deuxième type de thermostat. Il est important de le mettre en mode réduit si vous savez que vous ne serez pas présent le lendemain.',
    background: 'img_bg_cvc-regulateur.jpg',
    characterImg: 'img_miniature_cyril.png',
    image: 'img_asset_thermostat2.png',
    characterName: 'Cyril',
  },
  {
    id: 'rece6lMJenAtOmjdR',
    order: 7,
    type: 'DIALOG',
    site: ['IDEEV', 'HM'],
    thematique: 'SORBONNES',
    text: 'Un autre point à retenir est qu’il ne faut pas faire fonctionner toutes les sorbonnes en même temps. Il est recommandé de se renseigner sur le foisonnement prévu dans le laboratoire.',
    background: 'img_bg_sorbonne1.jpg',
    characterImg: 'img_chr_sorbonne2.png',
    characterName: 'Sonia',
  },
  {
    id: 'receQGTx6QZoXicYc',
    order: 10,
    type: 'DIALOG_IMAGE',
    site: ['HM'],
    thematique: 'ASCENSEURS',
    text: 'Les autres étages (RDC, 1, 2, 3) ne sont accessibles qu’avec un badge spécifique.',
    characterImg: 'img_miniature_alix.png',
    image: 'img_asset_47_ascenseur.png',
    characterName: 'Alix',
  },
  {
    id: 'receQdB2JS8Je4iZ8',
    order: 7,
    type: 'DIALOG',
    site: ['IDEEV'],
    thematique: 'ECLAIRAGES',
    text: 'L’extinction se fait à la fin de la temporisation, si elle n’a détecté personne d’autre, ou si la lumière naturelle extérieure est suffisante. Plus il y a de surface vitrée, moins on a besoin d’éclairer ! Pratique et écologique !',
    background: 'img_bg-laboratory.png',
    characterImg: 'img_chr_eva1.png',
    characterName: 'Eva',
  },
  {
    id: 'receaH0WmazpBxAQH',
    order: 13,
    type: 'RECAP',
    site: ['IDEEV'],
    thematique: 'ASCENSEURS',
    text: 'En résumé, il y a 5 ascenseurs sur le site Ideev avec les particularités suivantes : ',
    background: 'img_bg_ascenceur.jpg',
    characterImg: 'img_miniature_alix.png',
    characterName: 'Alix',
    recap1: '#1 : ascenseurs libres d’accès et sans lecteur de badge',
    recap2: '#2 : 3 ascenseurs monte-personnes',
    recap3:
      '#3 : 2 ascenseurs mixtes  (monte-personnes et monte-charges) dont un pouvant transporter de l’azote',
  },
  {
    id: 'recelYUnWOIbZKPJC',
    order: 19,
    type: 'RECAP',
    site: ['IDEEV', 'HM'],
    thematique: 'SORBONNES',
    text: ' Vous pouvez retenir qu’il y a 650 sorbonnes sur nos deux sites : ',
    background: 'img_bg_sorbonne2.jpg',
    characterImg: 'img_miniature_sorbonne.png',
    characterName: 'Sonia',
    recap1:
      '#1 : Préparez soigneusement votre poste de travail et identifiez l’ensemble des commandes',
    recap2: '#2 : Ne pas utiliser toutes sorbonnes d’une salle simultanément ',
    recap3:
      '#3 : Remettre les sorbonnes en mode automatique après l’utilisation',
  },
  {
    id: 'recf4ag2gthsx5CeW',
    order: 4,
    type: 'DIALOG',
    site: ['IDEEV'],
    thematique: 'ASCENSEURS',
    text: 'Voici où sont situés les ascenseurs du site IDEEV.​',
    background: 'img_bg_ascenceur.jpg',
    characterImg: 'img_chr_alix2.png',
    characterName: 'Alix',
  },
  {
    id: 'recfL9mAaeSZzdCOo',
    order: 11,
    type: 'DIALOG',
    site: ['IDEEV'],
    thematique: 'ECLAIRAGES',
    text: 'Pensez à bien les éteindre en poussant ce bouton, ils n’ont pas de mode automatique ! ​',
    background: 'img_bg-laboratory.png',
    characterImg: 'img_chr_eva2.png',
    image: 'img_asset_photo-salle-cours.png',
    characterName: 'Eva',
  },
  {
    id: 'recfccNdcF8ybBKzc',
    order: 8,
    type: 'DIALOG_IMAGE',
    site: ['IDEEV'],
    thematique: 'ASCENSEURS',
    text: 'Le couloir du troisième étage, quant à lui, est réservé aux techniciens de maintenance donc pas de raison d’y aller si vous n’êtes pas habilité et que vous n’avez pas de badge !​',
    characterImg: 'img_miniature_alix.png',
    image: 'img_asset_30_ascenseur.png',
    characterName: 'Alix',
  },
  {
    id: 'recgOvlGqG0kHncRj',
    order: 15,
    type: 'QCU',
    site: ['IDEEV', 'HM'],
    thematique: 'CONTROLS',
    text: 'Il faut obligatoirement avoir son badge pour pouvoir circuler librement sur le site​',
    answers: [
      {
        text: 'VRAI',
        isCorrect: false,
      },
      {
        text: 'FAUX',
        isCorrect: true,
      },
    ],
    feedbackCorrect:
      'Bien vu ! ​Les badges ne sont nécessaires que pour certaines zones, certaines personnes et sur certains horaires  De 7h à 20h, la circulation est libre pour les zones d’enseignement.',
    feedbackIncorrect:
      'Les badges ne sont nécessaires que pour certaines zones, certaines personnes et sur certains horaires  De 7h à 20h, la circulation est libre pour les zones d’enseignement.',
    background: 'img_bg_porte-badge.jpg',
    characterImg: 'img_miniature_carl.png',
    characterName: 'Carl',
  },
  {
    id: 'recgYMpYAW2D8DrjF',
    order: 9,
    type: 'DIALOG_IMAGE',
    site: ['HM'],
    thematique: 'ASCENSEURS',
    text: 'Ces étages sont les seuls accessibles à tous les étudiants car pas besoin de badge.',
    characterImg: 'img_miniature_alix.png',
    image: 'img_asset_46_ascenseur.png',
    characterName: 'Alix',
  },
  {
    id: 'recgqhzmpz0iQw1dG',
    order: 3,
    type: 'DIALOG',
    site: ['IDEEV'],
    thematique: 'ECLAIRAGES',
    text: 'La régulation peut être de deux sortes :​ La première, « tout ou rien », qui veut dire que, soit c’est allumé soit c’est éteint. La seconde, « graduée », qui indique que l’éclairage est variable en fonction de la luminosité et sur des plages précises.',
    background: 'img_bg-laboratory.png',
    characterImg: 'img_chr_eva1.png',
    characterName: 'Eva',
  },
  {
    id: 'rech6CFebDhxsYrDj',
    order: 12,
    type: 'QCU',
    site: ['IDEEV'],
    thematique: 'ASCENSEURS',
    text: 'Vrai ou faux ? Il existe trois types d’ascenseurs en tout.',
    answers: [
      {
        text: 'VRAI',
        isCorrect: false,
      },
      {
        text: 'FAUX',
        isCorrect: true,
      },
    ],
    feedbackCorrect:
      "En fait il en n'existe que deux des Monte-personnes et ascenseurs mixtes",
    feedbackIncorrect:
      'Pas tout à fait ! ​Il existe des monte-personnes et des ascenseurs mixtes.​',
    background: 'img_bg_ascenceur.jpg',
    characterImg: 'img_miniature_alix.png',
    characterName: 'Alix',
  },
  {
    id: 'rechI0KbAHGgjU1nm',
    order: 3,
    type: 'DIALOG',
    site: ['IDEEV', 'HM'],
    thematique: 'CVC',
    text: "Mais allons à l’essentiel, à savoir, la sobriété énergétique ! Les équipements thermiques ont été dimensionnés pour chauffer à 19°C et , climatiser les laboratoires à 26°C, ainsi que rafraichir les locaux d'enseignement.Plutôt confortable, non ?",
    background: 'img_bg_cvc-regulateur.jpg',
    characterImg: 'img_chr_cyril1.png',
    characterName: 'Cyril',
  },
  {
    id: 'reciVKQR2YmMMNtNM',
    order: 14,
    type: 'DIALOG',
    site: ['HM'],
    thematique: 'ECLAIRAGES',
    text: "Attention, vous pourriez vous retrouver dans le noir au moment de l’extinction du bâtiment à 20h. À ce moment, les activités ou déplacements dans le local peuvent engendrer des risques pour votre sécurité. Cependant il est possible de relancer l'éclairage grâce à des boutons poussoirs. Soyez donc prudents !​",
    characterImg: 'img_chr_eva1.png',
    characterName: 'Eva',
  },
  {
    id: 'recijrJFzg1ieBuDi',
    order: 11,
    type: 'DIALOG_IMAGE',
    site: ['HM'],
    thematique: 'ASCENSEURS',
    text: '<c1>Le transport d’azote</c1> dans ces <c2>deux ascenseurs mixtes</c2> est quant à lui possible, sans transport de personnel, grâce à une clé et une procédure spécifique qui inhibe toute autre commande.​',
    characterImg: 'img_miniature_alix.png',
    image: 'img_asset_48_ascenseur.png',
    characterName: 'Alix',
  },
  {
    id: 'reckxG7g5ZIa8tADt',
    order: 18,
    type: 'DRAG_DROP',
    site: ['HM'],
    thematique: 'ECLAIRAGES',
    text: 'Quel est le fonctionnement de l’éclairage des couloirs ?',
    answers: [
      {
        text: 'Sur seuil de luminosité​',
        isCorrect: true,
      },
      {
        text: 'Fonctionnement 1/3 – 2/3​',
        isCorrect: true,
      },
      {
        text: 'Sur interrupteur​',
        isCorrect: false,
      },
      {
        text: 'Avec jeu de clé​',
        isCorrect: false,
      },
    ],
    feedbackCorrect:
      'C’est ça ! Leur fonctionnement est particulier : ils fonctionnent en 1/3 – 2/3. C’est-à-dire qu’il y a plusieurs luminaires et que seul 1/3 sont programmés pour rester allumés constamment. ',
    feedbackIncorrect:
      'Leur fonctionnement est particulier : ils fonctionnent en 1/3 – 2/3. C’est-à-dire qu’il y a plusieurs luminaires et que seul 1/3 sont programmés pour rester allumés constamment. ',
    background: 'img_bg_couloir.jpg',
    characterImg: 'img_miniature_eva.png',
    characterName: 'Eva',
  },
  {
    id: 'recl9JxVLN2VfjvpL',
    order: 6,
    type: 'DIALOG',
    site: ['HM'],
    thematique: 'ECLAIRAGES',
    text: 'C’est le cas pour les sanitaires, les douches, les couloirs, les escaliers, et le hall quand la luminosité extérieure est faible. ',
    background: 'img_bg_couloir.jpg',
    characterImg: 'img_chr_eva2.png',
    characterName: 'Eva',
  },
  {
    id: 'reclQRiwz1sExeM1X',
    order: 2,
    type: 'DIALOG',
    site: ['IDEEV'],
    thematique: 'ECLAIRAGES',
    text: 'Laissez-moi vous apporter mes lumières!​ Dans nos deux sites, nous avons une quinzaine de types d’éclairage. Certains sont à commande locale, ça veut dire qu’elle est située dans ou à proximité du local, alors que d’autres sont automatiques.',
    background: 'img_bg-laboratory.png',
    characterImg: 'img_chr_eva2.png',
    characterName: 'Eva',
  },
  {
    id: 'reclffPecxcKBHVw7',
    order: 1,
    type: 'DIALOG',
    site: ['IDEEV', 'HM'],
    thematique: 'CVC',
    text: 'Enchanté ! Je m’appelle Cyril. Si vous êtes venu jusqu’à moi c’est pour qu’on parle des Chauffages Ventilations Climatisations, je suppose. <br />Pour information la ventilation représente environ 50% des consommations de ce bâtiment.',
    background: 'img_bg_cvc-regulateur.jpg',
    characterImg: 'img_chr_cyril1.png',
    characterName: 'Cyril',
  },
  {
    id: 'reclrbsKIBTllGwHp',
    order: 16,
    type: 'DIALOG',
    site: ['IDEEV', 'HM'],
    thematique: 'SORBONNES',
    text: 'Allez, voyons voir ce que vous avez compris !',
    background: 'img_bg_sorbonne2.jpg',
    characterImg: 'img_chr_sorbonne2.png',
    characterName: 'Sonia',
  },
  {
    id: 'recmG4OtTYWZjZUYr',
    order: 9,
    type: 'DIALOG',
    site: ['IDEEV', 'HM'],
    thematique: 'STORES',
    text: 'Si vous appuyez sur les touches de la commande, vous arrêtez complètement la programmation de ce mode automatique pour la journée. C’est dommage car il est prévu pour être le plus optimal pour votre confort thermique et lumineux.',
    background: 'img_bg_store1.jpg',
    characterImg: 'img_chr_sami1.png',
    characterName: 'Sami',
  },
  {
    id: 'recme4djCuMrdskmb',
    order: 1,
    type: 'DIALOG',
    site: ['IDEEV', 'HM'],
    thematique: 'SORBONNES',
    text: 'Bonjour, Sonia, enchantée ! Si vous voulez parler des sorbonnes, je suis la personne qu’il vous faut ! D’ailleurs, mieux vaut savoir de quoi on parle car il n’y en a pas moins de… 650 sur les deux sites et 6 types différents !',
    background: 'img_bg_sorbonne1.jpg',
    characterImg: 'img_chr_sorbonne1.png',
    characterName: 'Sonia',
  },
  {
    id: 'recmmUGt51mxsBYOb',
    order: 7,
    type: 'DIALOG_IMAGE',
    site: ['IDEEV', 'HM'],
    thematique: 'CONTROLS',
    text: '… à l’extérieur des ascenseurs.',
    background: 'img_bg_porte-badge.jpg',
    characterImg: 'img_miniature_carl.png',
    image: 'img_asset_badge-ascenseur-ext.png',
    characterName: 'Carl',
  },
  {
    id: 'recn6RJIenfcruc47',
    order: 12,
    type: 'DIALOG',
    site: ['IDEEV', 'HM'],
    thematique: 'CONTROLS',
    text: 'Si vous rencontrez un problème, appelez le PC sécurité : 01 69 15 74 46 pour IDEEV et 01 69 15 41 20 pour Henri Moissan. Vous pouvez les contacter 24/24h.​',
    background: 'img_bg_porte-badge.jpg',
    characterImg: 'img_chr_carl2.png',
    characterName: 'Carl',
  },
  {
    id: 'recnDlmbX3WwqHM3N',
    order: 17,
    type: 'RECAP',
    site: ['IDEEV', 'HM'],
    thematique: 'STORES',
    text: ' Vous pouvez retenir qu’il y a 2 types de stores : ',
    background: 'img_bg_store1.jpg',
    characterImg: 'img_miniature_sami.png',
    characterName: 'Sami',
    recap1:
      '#1 : Il existe 2 types de stores et 2 modes de fonctionnement : vénitiens et volets roulants en mode automatique ou manuel ',
    recap2:
      '#2 : Le mode automatique est prévu pour un confort thermique et lumineux optimal',
    recap3:
      '#3 : Pour limiter les consommations d’énergie, il est préconisé de laisser les stores en mode automatique ',
  },
  {
    id: 'recnZRVmS7D9k6mqZ',
    order: 13,
    type: 'DIALOG_IMAGE',
    site: ['HM'],
    thematique: 'ASCENSEURS',
    text: '…va du sous-sol au 4ème étage avec transport possible d’azote. C’est donc le seul de cette zone qui permet de transporter du matériel. C’est aussi le seul ascenseur accessible aux associations en dehors des heures d’ouverture du site.​',
    characterImg: 'img_miniature_alix.png',
    image: 'img_asset_50_ascenseur.png',
    characterName: 'Alix',
  },
  {
    id: 'recoX9QXMKu6IFvgP',
    order: 6,
    type: 'DIALOG_IMAGE',
    site: ['IDEEV', 'HM'],
    thematique: 'CONTROLS',
    text: 'Vous trouverez des systèmes pour badger à l’intérieur et…',
    characterImg: 'img_miniature_carl.png',
    image: 'img_asset_badge-ascenseur-int.png',
    characterName: 'Carl',
  },
  {
    id: 'recr0jPIoUmCBLvvl',
    order: 16,
    type: 'CLICK_IMAGE',
    site: ['HM'],
    thematique: 'ECLAIRAGES',
    text: ' Comment contrôler la lumière dans cette salle de cours ? ',
    grilleCoords: 'D1, A3, D3',
    feedbackCorrect:
      'Bien vu !  ​Dans les petites salles de cours avec un tableau blanc, la lumière s’allume grâce à un détecteur de présence et une commande au tableau. ',
    feedbackIncorrect:
      'Dans les petites salles de cours avec un tableau blanc, la lumière s’allume grâce à un détecteur de présence et une commande au tableau. ',
    background: 'img_bg_couloir.jpg',
    characterImg: 'img_miniature_eva.png',
    image: 'img_asset_photo-salle-cours.png',
    characterName: 'Eva',
  },
  {
    id: 'recrIlgTlF51Ohpgt',
    order: 19,
    type: 'RECAP',
    site: ['HM'],
    thematique: 'ECLAIRAGES',
    text: 'Sur les sites Ideev et Henri Moissan, il y a une quinzaine de types d’éclairage avec des particularités : ​',
    background: 'img_bg_couloir.jpg',
    characterImg: 'img_miniature_eva.png',
    characterName: 'Eva',
    recap1:
      '#1 : 3 grandes familles : interrupteur, bouton-poussoir, détecteur de présence',
    recap2:
      '#2 : Les pièces avec des détecteurs de présence ont aussi des boutons pour réguler la lumière de façon autonome.',
    recap3:
      '#3 : Pour les pièces avec des boutons poussoirs, pensez à bien éteindre lorsque vous partez',
  },
  {
    id: 'recrNKyaO96pahyoT',
    order: 1,
    type: 'DIALOG',
    site: ['IDEEV'],
    thematique: 'ECLAIRAGES',
    text: 'Bonjour, je suis Eva.​ Vous êtes ici pour l’éclairage, c’est bien ça ?​<br />Pour information les éclairages représentent environ 5% des consommations de ce bâtiment. ',
    background: 'img_bg-laboratory.png',
    characterImg: 'img_chr_eva1.png',
    characterName: 'Eva',
  },
  {
    id: 'recrSb3xPnoMCrozW',
    order: 7,
    type: 'DIALOG',
    site: ['HM'],
    thematique: 'ECLAIRAGES',
    text: 'L’extinction se fait à la fin de la temporisation, si elle n’a détecté personne d’autre, ou si la lumière naturelle extérieure est suffisante. Plus il y a de surface vitrée, moins on a besoin d’éclairer ! Pratique et écologique !',
    background: 'img_bg_couloir.jpg',
    characterImg: 'img_chr_eva1.png',
    characterName: 'Eva',
  },
  {
    id: 'recs1XGTfdTzHY4fq',
    order: 8,
    type: 'DIALOG',
    site: ['HM'],
    thematique: 'ECLAIRAGES',
    text: 'Le fonctionnement est particulier : les éclairages fonctionnent en 1/3 – 2/3. C’est-à-dire qu’il y a plusieurs luminaires et que seul 1/3 sont programmés pour rester allumés constamment.',
    background: 'img_bg_couloir.jpg',
    characterImg: 'img_chr_eva2.png',
    characterName: 'Eva',
  },
  {
    id: 'recsx08AU0JLoGq3m',
    order: 14,
    type: 'QCU',
    site: ['IDEEV', 'HM'],
    thematique: 'STORES',
    text: 'En été, à quelle heure, les volets roulants s’activent-ils en mode automatique ?',
    answers: [
      {
        text: 'À 7h00 et à 20h00',
        isCorrect: true,
      },
      {
        text: 'À 8h00 et à 20h00',
        isCorrect: false,
      },
      {
        text: 'À 7h00 et à 22h00',
        isCorrect: false,
      },
      {
        text: 'À 8h00 et à 22h00',
        isCorrect: false,
      },
    ],
    feedbackCorrect:
      'Nickel ! ​En été, les volets roulants s’activent à 7h00 pour se fermer et à 22h pour s’ouvrir. Et en hiver, c’est l’inverse, ils s’ouvrent le matin et se referment à 20h. ',
    feedbackIncorrect:
      'En été, les volets roulants s’activent à 7h00 pour se fermer et à 22h pour s’ouvrir. Et en hiver, c’est l’inverse, ils s’ouvrent le matin et se referment à 20h. ​',
    background: 'img_bg_store1.jpg',
    characterImg: 'img_miniature_sami.png',
    characterName: 'Sami',
  },
  {
    id: 'rect8oN1j6r8BB2Lb',
    order: 4,
    type: 'DIALOG_IMAGE',
    site: ['IDEEV'],
    thematique: 'ECLAIRAGES',
    text: 'Dans certains bureaux, laboratoires ou certains locaux techniques, on retrouve des interrupteurs classiques et des boutons-poussoirs. Ces éclairages sont toujours positionnés près de la porte. ',
    background: 'img_bg-laboratory.png',
    characterImg: 'img_miniature_eva.png',
    image: 'img_asset_interrupteur.png',
    characterName: 'Eva',
  },
  {
    id: 'rectH0Zll7zysb2ZB',
    order: 11,
    type: 'DIALOG',
    site: ['HM'],
    thematique: 'ECLAIRAGES',
    text: 'Pensez à bien les éteindre en poussant ce bouton, ils n’ont pas de mode automatique ! ​',
    background: 'img_bg_couloir.jpg',
    characterImg: 'img_chr_eva2.png',
    image: 'img_asset_photo-salle-cours.png',
    characterName: 'Eva',
  },
  {
    id: 'rectYKLZUiMVVgeBo',
    order: 4,
    type: 'DIALOG',
    site: ['IDEEV', 'HM'],
    thematique: 'CONTROLS',
    text: 'Mais rassurez-vous : sur certains horaires, le contrôle d’accès n’est pas actif. Par exemple entre 7h et 20h, en général pendant les temps d’enseignement, la circulation est libre dans les bâtiments d’enseignement.​',
    background: 'img_bg_porte-badge.jpg',
    characterImg: 'img_chr_carl2.png',
    characterName: 'Carl',
  },
  {
    id: 'rectteYPdXbHbJytD',
    order: 1,
    type: 'DIALOG',
    site: ['IDEEV', 'HM'],
    thematique: 'CONTROLS',
    text: 'Mot de passe ? ',
    background: 'img_bg_porte-badge.jpg',
    characterImg: 'img_chr_carl1.png',
    characterName: 'Carl',
  },
  {
    id: 'recv2C08KKh3uUprf',
    order: 3,
    type: 'DIALOG',
    site: ['HM'],
    thematique: 'ECLAIRAGES',
    text: 'La régulation peut être de deux sortes :​ La première, « tout ou rien », qui veut dire que soit c’est allumé soit c’est éteint. La seconde, « graduée », qui indique que l’éclairage est variable en fonction de la luminosité et sur des plages précises.',
    background: 'img_bg_couloir.jpg',
    characterImg: 'img_chr_eva1.png',
    characterName: 'Eva',
  },
  {
    id: 'recv6r92jGBgmwXei',
    order: 10,
    type: 'DIALOG_IMAGE',
    site: ['IDEEV'],
    thematique: 'ECLAIRAGES',
    text: 'Certaines salles de cours sont équipées de Tableaux Blancs. ​',
    background: 'img_bg-laboratory.png',
    characterImg: 'img_miniature_eva.png',
    image: 'img_asset_photo-salle-cours.png',
    characterName: 'Eva',
  },
  {
    id: 'recvOe9TatVgnfvvq',
    order: 3,
    type: 'DIALOG',
    site: ['HM'],
    thematique: 'ASCENSEURS',
    text: 'Je compte donc sur toi pour prendre les marches si tu le peux ! ​En attendant, je vais te faire une rapide présentation. Regarde sur cette carte :',
    background: 'img_bg_ascenceur.jpg',
    characterImg: 'img_chr_alix1.png',
    characterName: 'Alix',
  },
  {
    id: 'recvRbFEragupUJCo',
    order: 7,
    type: 'DIALOG_IMAGE',
    site: ['IDEEV'],
    thematique: 'ASCENSEURS',
    text: 'Allez, je termine avec les ascenseurs du site IDEEV en t’indiquant où-est-ce qu’ils t’emmènent ! ​Et bien les 5 ascenseurs vous permettront de vous déplacer entre le rez-de-chaussée et les niveaux 1 et 2 ! Cependant, seuls ces deux ascenseurs mixtes (ici en orange) peuvent se rendre au troisième étage.',
    characterImg: 'img_miniature_alix.png',
    image: 'img_asset_30_ascenseur.png',
    characterName: 'Alix',
  },
  {
    id: 'recwPhhSJlcMXCKgz',
    order: 4,
    type: 'DIALOG_IMAGE',
    site: ['IDEEV', 'HM'],
    thematique: 'SORBONNES',
    text: 'Vous voyez la commande ? Elle sert à configurer la guillotine en manuel ou auto. Là, elle est en mode manuel. Tu peux le voir si les boutons de gauche (position haute ou basse) sont bleus.',
    characterImg: 'img_miniature_sorbonne.png',
    image: 'img_bg_sorbonne1.jpg',
    characterName: 'Sonia',
  },
  {
    id: 'recxe0XwI6xCBe6mu',
    order: 12,
    type: 'DIALOG',
    site: ['IDEEV', 'HM'],
    thematique: 'SORBONNES',
    text: 'Il est possible de rencontrer quelques anomalies. Dans ce cas, n’hésitez pas à consulter le manuel de l’utilisateur ou à contacter les services dédiés.',
    background: 'img_bg_sorbonne2.jpg',
    characterImg: 'img_chr_sorbonne2.png',
    characterName: 'Sonia',
  },
  {
    id: 'recxvEuZOy1bXHlMN',
    order: 13,
    type: 'DIALOG_IMAGE',
    site: ['IDEEV'],
    thematique: 'ECLAIRAGES',
    text: 'Pour les amphithéâtres du site Henri Moissan, il y a  des détecteurs de présence : l’allumage est automatique. Il est également possible de modifier la luminosité via des commandes sur la tablette connectée en pupitre. ​',
    background: 'img_bg-laboratory.png',
    characterImg: 'img_miniature_eva.png',
    image: 'img_asset_emphitheatre.png',
    characterName: 'Eva',
  },
  {
    id: 'recxvHVjzMVEeQSQJ',
    order: 11,
    type: 'FRISE',
    site: ['IDEEV'],
    thematique: 'ASCENSEURS',
    text: 'Comment pouvez-vous vous rendre au 2ème étage du site IDEEV ?',
    answers: [
      {
        text: 'Avec un badge cabine',
        isCorrect: false,
      },
      {
        text: 'Avec un badge palier',
        isCorrect: false,
      },
      {
        text: 'Avec un badge spécifique',
        isCorrect: false,
      },
      {
        text: 'En accès libre',
        isCorrect: true,
      },
    ],
    feedbackCorrect:
      'Effectivement ! <br />Vous avez la <c1>possibilité d’emprunter</c1> les <c2>5 ascenseurs</c2> en accès libre. Certains sont dédiés aux personnes et d’autres permettent aussi le monte-charge.',
    feedbackIncorrect:
      'Vous avez la possibilité d’emprunter les 5 ascenseurs en accès libre. Certains sont dédiés aux personnes et d’autres permettent aussi le monte-charge.',
    background: 'img_bg_ascenceur.jpg',
    characterImg: 'img_miniature_alix.png',
    characterName: 'Alix',
  },
  {
    id: 'recytNNmvyqMfu77i',
    order: 17,
    type: 'QCM',
    site: ['IDEEV'],
    thematique: 'ECLAIRAGES',
    text: 'Dans quelle pièce devez-vous faire attention à la coupure automatique avant 7h et après 20h du lundi au samedi matin ? ',
    answers: [
      {
        text: 'Salle de cours',
        isCorrect: true,
      },
      {
        text: 'Le local de zone de laboratoire',
        isCorrect: true,
      },
      {
        text: 'L’amphithéâtre',
        isCorrect: true,
      },
      {
        text: 'Le couloir',
        isCorrect: true,
      },
    ],
    feedbackCorrect:
      "Oui ! ​Ici toutes les réponses sont bonnes, car à 20h tout s'éteint et passe en allumage sur détection de mouvement.",
    feedbackIncorrect:
      "Ici toutes les réponses sont bonnes, car à 20h tout s'éteint et passe en allumage sur détection de mouvement.",
    background: 'img_bg-laboratory.png',
    characterImg: 'img_miniature_eva.png',
    characterName: 'Eva',
  },
  {
    id: 'reczLCLxg3dmkLLB9',
    order: 16,
    type: 'DRAG_DROP',
    site: ['IDEEV', 'HM'],
    thematique: 'STORES',
    text: 'Que se passe-t-il si vous faites un appui court sur les boutons de la commande locale ?',
    answers: [
      {
        text: 'Les volets ou stores à lames montent',
        isCorrect: false,
      },
      {
        text: 'Les volets ou stores à lames descendent',
        isCorrect: false,
      },
      {
        text: 'Les lames des volets changent de position',
        isCorrect: true,
      },
      {
        text: 'Les lames des stores changent de position.',
        isCorrect: false,
      },
    ],
    feedbackCorrect:
      "Bien joué ! ​Un appui court sur la flèche du haut ou la flèche du bas permet la rotation des lamelles d'un pas (applicable aux stores à lames uniquement).",
    feedbackIncorrect:
      "Un appui court sur la flèche du haut ou la flèche du bas permet la rotation des lamelles d'un pas (applicable aux stores à lames uniquement).​",
    background: 'img_bg_store1.jpg',
    characterImg: 'img_miniature_sami.png',
    characterName: 'Sami',
  },
  {
    id: 'reczyMmbsKuCJmugD',
    order: 2,
    type: 'DIALOG',
    site: ['IDEEV'],
    thematique: 'ASCENSEURS',
    text: 'Les ascenseurs du site IDEEV sont en libre accès et sans lecteur de badge. La consommation totale par mois des ascenseurs du site IDEEV est de 250kWh environ. ',
    background: 'img_bg_ascenceur.jpg',
    characterImg: 'img_chr_alix2.png',
    characterName: 'Alix',
  },
];
